import Document16 from '@carbon/icons-react/es/document/16';
import { useBoolean } from 'ahooks';
import { Image, Popover, Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { RocketDocument16 } from 'components/atoms/icons';
import { SpaceTab } from 'data/space-tabs';

const Title = styled.div`
  display: flex;
  align-items: center;

  svg,
  .ant-image {
    margin-right: var(--spacing-03);
    flex-shrink: 0;
    color: var(--blue-60);

    &-img {
      display: block;
    }
  }
`;

const TabContent = ({ iconSrc, title }) => {
  const [imageError, { setTrue }] = useBoolean(false);

  return (
    <Title>
      {iconSrc ? (
        <>
          {imageError ? (
            <Document16 />
          ) : (
            <Image
              onError={setTrue}
              preview={false}
              alt={title}
              width={16}
              src={iconSrc}
            />
          )}
        </>
      ) : (
        <RocketDocument16 />
      )}
      <Typography.Text ellipsis>{title}</Typography.Text>
    </Title>
  );
};

export const Tab: FC<{ data: SpaceTab }> = ({ data }) => {
  const spaceTab = data;

  const iconSrc =
    Array.isArray(spaceTab.metaData?.links?.icon) &&
    spaceTab.metaData?.links?.icon[0]?.href;

  return (
    <Popover
      trigger={['hover']}
      placement="bottomLeft"
      mouseEnterDelay={0.8}
      content={<TabContent iconSrc={iconSrc} title={spaceTab.spaceTabTitle} />}
    >
      <div>
        <TabContent iconSrc={iconSrc} title={spaceTab.spaceTabTitle} />
      </div>
    </Popover>
  );
};
